"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
// accepts an array of items, and returns an array of items or array of items for bundles
exports.default = (function (items) {
    var _a = __read(items.reduce(function (arr, item) {
        if (item.properties && item.properties.parent_bundle_id) {
            arr[1].push(item);
        }
        else {
            arr[0].push(item);
        }
        return arr;
    }, [[], []]), 2), nonChildBundleItems = _a[0], childBundleItems = _a[1];
    var groupedItems = nonChildBundleItems.map(function (item) {
        var bundleId = item.properties && item.properties.bundle_id;
        var group = { item: item };
        if (bundleId) {
            group.children = childBundleItems.filter(function (child) { return child.properties && child.properties.parent_bundle_id === bundleId; });
        }
        return group;
    });
    if (groupedItems.length === 0 && childBundleItems.length) {
        console.error('Stranded child line items found in cart!');
    }
    return groupedItems;
});
